<template>
  <v-list-tile v-if="isAuthenticated">
    <v-list-tile-action>
      <img
        v-if="user && user.photo && user.photo.length"
        :src="user.photo"
        width="36px"
        height="36px"
        style="border-radius:50%;"
      />
      <v-icon v-else>account_circle</v-icon>
    </v-list-tile-action>
    <v-list-tile-content>
      <v-list-tile-title>{{ user.userName }}</v-list-tile-title>
      <v-list-tile-sub-title class="caption">{{ user.login }}</v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action>
      <v-btn icon slot="append" @click="userSignOut">
        <v-icon>exit_to_app</v-icon>
      </v-btn>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'UserTile',
  methods: {
    ...mapActions(['userSignOut'])
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    user() {
      return this.$store.state.auth.user
    }
  }
}
</script>

<style>
</style>
